// extracted by mini-css-extract-plugin
module.exports = {"info_blurb":"info-module--info_blurb--DoQ9H"};